// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/extension_enum.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { GenExtension, GenFile } from '@bufbuild/protobuf/codegenv2';
import { extDesc, fileDesc } from '@bufbuild/protobuf/codegenv2';
import type { EnumValueOptions } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_descriptor } from '@bufbuild/protobuf/wkt';

/**
 * Describes the file proto/v1/extension_enum.proto.
 */
export const file_proto_v1_extension_enum: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1wcm90by92MS9leHRlbnNpb25fZW51bS5wcm90bxITdm1zcGRiLmFwaS5wcm90by52MTozCgJkYhIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGOPUAyABKAlSAmRiOkEKCXR5cGVzZW5zZRIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGOTUAyABKAlSCXR5cGVzZW5zZUIqWihnby52bXNwZGIuYXBwL3BsYXRmb3JtL2ludGVybmFsL3Byb3RvL3YxYgZwcm90bzM',
    [file_google_protobuf_descriptor],
  );

/**
 * @generated from extension: string db = 60003;
 */
export const db: GenExtension<EnumValueOptions, string> =
  /*@__PURE__*/
  extDesc(file_proto_v1_extension_enum, 0);

/**
 * @generated from extension: string typesense = 60004;
 */
export const typesense: GenExtension<EnumValueOptions, string> =
  /*@__PURE__*/
  extDesc(file_proto_v1_extension_enum, 1);
